import React from 'react';
import {RecursiveTable, Table} from '../../../components/table/Table';
import {TableHeader} from '../../../components/table/Headers';
import {AddButton} from '../../../components/button/AddButton';
import {useInvoke} from '../../../controllers/useInvoke';
import {getCurrentMonth, useFilter} from '@unthinkable/react-filters';
import {
  GroupFilter,
  PeriodRangeMonthWiseBreakupFilter,
} from '../../../components/filter/Filters';
import CountCellRender from '../../../app-components/renders/CountCellRender';
import {getPreviousMonthWithDateParameters} from '../../../utils/util';
import {useAppStateContext} from '../../../providers/AppState';
import {useFetchData} from '../../../controllers/useFetchData';
import {Col, Row} from '@unthinkable/react-core-components';
import {RecursiveRender} from '@unthinkable/react-table';
import {TextRenderer} from '../../../components/form/Renderers';
import {useTheme} from '@unthinkable/react-theme';


export const KeyPerformanceIndicatorTable = props => {
  const {navigation} = props;
  const deleteInvoke = useInvoke({
    method: 'delete',
    eventSourceId: 'keyperformanceindicators',
  });

  const {applyFilter, filterValues, onChangeFilter} = useFilter({
    params: {
      period: getCurrentMonth(),
    },
  });
  const {params: filterParams} = filterValues;
  const {period} = filterParams;
  const previousMonthDate = getPreviousMonthWithDateParameters(
    period?.from,
    period?.to,
  );
  let addOnFilter = {};
  if (filterValues?.filter) {
    addOnFilter = {...addOnFilter, ...filterValues?.filter};
  }
  const invoke = useInvoke({
    method: 'post',
    eventSourceId: 'keyperformanceindicators',
  });
  const {colors} = useTheme();

  return (
    <Table
      eventSourceId={'keyperformanceindicators'}
      api={`/kpi/data`}
      filter={{...filterValues?.params, ...addOnFilter}}
      renderHeader={() => (
        <TableHeader
          title="Key Performance Indicator"
          actions={[
            <PeriodRangeMonthWiseBreakupFilter
              onChangeFilter={onChangeFilter}
              filterValues={filterValues}
              asParam
            />,
            <GroupFilter
              filterValues={filterValues}
              applyFilter={applyFilter}
              filters={[
                {
                  type: 'autoComplete',
                  label: 'Kpi',
                  api: '/keyperformanceindicators',
                  field: '_id',
                  keyField: '_id',
                  valueField: 'name',
                  placeholder: 'Select KPI',
                  suggestionField: 'name',
                },
              ]}
            />,
            <AddButton
              title="Add"
              view="add-key-perfermance-indicator"
              params={props?.route?.params}
            />,
          ]}
        />
      )}
      // fields={{
      //   kra_id: {name: 1},
      //   name: 1,
      //   description: 1,
      //   api: 1,
      //   entity: {label: 1},
      //   role: 1,
      //   department: {name: 1},
      // }}
      columns={[
        {
          field: 'kra_id.name',
          header: 'KRA',
          responsive: 'sm',
        },
        {
          field: 'name',
          header: 'KPI',
          responsive: 'sm',
        },
        {
          field: 'owner',
          header: 'Owners',
          // responsive: 'sm',
          type: 'userAvatarGroup',
        },
        {
          header: 'Current',
          align: 'right',
          render: CountCellRender,
          count_field: 'current_value',
          width: 150,
          onPress: ({row}) => {
            const route = row?.api?.view;
            navigation.navigate(route, {
              period: {...filterValues?.params?.period},
              forKpi: true,
            });
          },
        },
        {
          header: 'Previous',
          align: 'right',
          render: CountCellRender,
          count_field: 'previous_value',
          width: 150,
          // type: 'text',
          onPress: ({row}) => {
            const route = row?.api?.view;
            navigation.navigate(route, {
              period: {...previousMonthDate},
              forKpi: true,
            });
          },
        },
        {
          field: 'variance',
          header: 'Variance',
          type: 'text',
          width: 150,
          render: ({row}) => {
            let variance =  (row.variance).toString() || "";
            const varArray = variance.split('(')
            variance = varArray[0]
            return (
              <TextRenderer
                style={{
                  color:
                  variance < 0
                      ? colors.ERROR_HIGH
                      : colors.SUCCESS_HIGH,
                }}
                value={
                  row.variance
                }
              />
            )
          }
        },
      ]}
      moreActions={() => [
        {
          title: 'Edit',
          onPress: ({row}) => {
            navigation.navigate('edit-key-performance-indicator', {row});
          },
        },
        {
          title: 'Delete',
          confirm: {
            title: 'Delete',
            message: 'Are you sure you want to Delete?',
            confirmText: 'Delete',
          },
          onPress: ({row}) => {
            deleteInvoke({
              uri: `/keyperformanceindicators/${row?._id}`,
              props: {},
            });
          },
        },
        {
          title: 'Generate Acheivement',
          onPress: ({row}) => {
            invoke({
              uri: '/saveKPIAchievement',
              props: {
                ...filterValues?.params,
                ...addOnFilter,
              },
            });
          },
        },
      ]}
      {...props}
    />
  );
};

export const AllKeyPerformanceIndicatorTable = props => {
  const {navigation} = props;
  const deleteInvoke = useInvoke({
    method: 'delete',
    eventSourceId: 'keyperformanceindicators',
  });

  const {applyFilter, filterValues, onChangeFilter} = useFilter({
    // params: {
    //   period: getCurrentMonth(),
    // },
  });
  // const {period = {}} = filterValues?.params;
  // const previousPeriod = {};
  // if (period.filterOf === 'Month') {
  //   (previousPeriod.from = moment(period.from)
  //     .subtract(1, 'M')
  //     .startOf('M')
  //     .toDate()),
  //     (previousPeriod.to = moment(period.from)
  //       .subtract(1, 'M')
  //       .endOf('M')
  //       .toDate());
  // }
  return (
    <Table
      eventSourceId={'keyperformanceindicators'}
      api={`/keyperformanceindicators`}
      filter={filterValues?.params}
      renderHeader={() => (
        <TableHeader
          title="Key Performance Indicator"
          actions={[
            <AddButton
              title="Add"
              view="add-key-perfermance-indicator"
              params={props?.route?.params}
            />,
          ]}
        />
      )}
      fields={{
        kra_id: {name: 1},
        name: 1,
        description: 1,
        api: 1,
        index: 1,
        entity: {label: 1},
        role: 1,
        department: {name: 1},
        owner: {name: 1, color: 1},
        parent_kpi: {name: 1},
      }}
      sort={{index: -1}}
      columns={[
        {
          field: 'kra_id.name',
          header: 'KRA',
          responsive: 'sm',
        },
        {
          field: 'name',
          header: 'KPI',
          responsive: 'sm',
        },
        {
          field: 'parent_kpi.name',
          header: 'Parent Kpi',
          responsive: 'sm',
        },
        {
          field: 'owner',
          header: 'Owners',
          // responsive: 'sm',
          type: 'userAvatarGroup',
        },
        {
          field: 'department.name',
          header: 'Department',
          responsive: 'sm',
        },
        {
          field: 'entity.label',
          header: 'Entity',
          width: 150,
        },
        {
          field: 'role',
          header: 'Role',
          width: 100,
        },
      ]}
      moreActions={() => [
        {
          title: 'Edit',
          onPress: ({row}) => {
            navigation.navigate('edit-key-performance-indicator', {row});
          },
        },
        {
          title: 'Delete',
          confirm: {
            title: 'Delete',
            message: 'Are you sure you want to Delete?',
            confirmText: 'Delete',
          },
          onPress: ({row}) => {
            deleteInvoke({
              uri: `/keyperformanceindicators/${row?._id}`,
              props: {},
            });
          },
        },
      ]}
      {...props}
    />
  );
};

// export default KeyPerformanceIndicatorTable;

export const KeyPerformanceIndicatorAchievementTables = props => {
  const {navigation} = props;
  const deleteInvoke = useInvoke({
    method: 'delete',
    eventSourceId: 'keyperformanceindicators',
  });

  const {applyFilter, filterValues, onChangeFilter} = useFilter({
    params: {
      period: getCurrentMonth(),
    },
  });
  const {params: filterParams} = filterValues;
  const {period} = filterParams;
  const previousMonthDate = getPreviousMonthWithDateParameters(
    period?.from,
    period?.to,
  );
  const {colors} = useTheme();

  return (
    <Table
      eventSourceId={'keyperformanceindicators'}
      api={`/kpi/achievement-data`}
      filter={filterValues?.params}
      renderHeader={() => (
        <TableHeader
          title="Key Performance Indicator"
          actions={[
            <PeriodRangeMonthWiseBreakupFilter
              onChangeFilter={onChangeFilter}
              filterValues={filterValues}
              asParam
            />,
            <AddButton
              title="Add"
              view="add-key-perfermance-indicator"
              params={props?.route?.params}
            />,
          ]}
        />
      )}
      // fields={{
      //   kra_id: {name: 1},
      //   name: 1,
      //   description: 1,
      //   api: 1,
      //   entity: {label: 1},
      //   role: 1,
      //   department: {name: 1},
      // }}
      columns={[
        {
          field: 'kra_id.name',
          header: 'KRA',
          responsive: 'sm',
        },
        {
          field: 'kpi_id.name',
          header: 'KPI',
          responsive: 'sm',
        },
        {
          field: 'parent_kpi.name',
          header: 'Parent Kpi',
          responsive: 'sm',
        },
        {
          field: 'owner',
          header: 'Owners',
          // responsive: 'sm',
          type: 'userAvatarGroup',
        },
        {
          header: 'Current',
          align: 'right',
          render: CountCellRender,
          count_field: 'current_value',
          width: 150,
          onPress: ({row}) => {
            const route = row?.api?.view;
            navigation.navigate(route, {
              period: {...filterValues?.params?.period},
              forKpi: true,
            });
          },
        },
        {
          header: 'Previous',
          align: 'right',
          render: CountCellRender,
          count_field: 'previous_value',
          width: 150,
          // type: 'text',
          onPress: ({row}) => {
            const route = row?.api?.view;
            navigation.navigate(route, {
              period: {...previousMonthDate},
              forKpi: true,
            });
          },
        },
        {
          field: 'variance',
          header: 'Variance',
          type: 'text',
          width: 150,
          render: ({row}) => {
            let variance =  (row.variance).toString() || "";
            const varArray = variance.split('(')
            variance = varArray[0]
            return (
              <TextRenderer
                style={{
                  color:
                  variance < 0
                      ? colors.ERROR_HIGH
                      : colors.SUCCESS_HIGH,
                }}
                value={
                  row.variance
                }
              />
            )
          }
        },
      ]}
      moreActions={() => [
        // {
        //   title: 'Edit',
        //   onPress: ({row}) => {
        //     navigation.navigate('edit-key-performance-indicator', {row});
        //   },
        // },
        {
          title: 'Delete',
          confirm: {
            title: 'Delete',
            message: 'Are you sure you want to Delete?',
            confirmText: 'Delete',
          },
          onPress: ({row}) => {
            deleteInvoke({
              uri: `/keyperformanceindicators/${row?._id}`,
              props: {},
            });
          },
        },
      ]}
      {...props}
    />
  );
};

export const KeyPerformanceIndicatorAchievementTableOwner = props => {
  const {navigation} = props;
  const deleteInvoke = useInvoke({
    method: 'delete',
    eventSourceId: 'keyperformanceindicators',
  });

  const {applyFilter, filterValues, onChangeFilter} = useFilter({
    params: {
      period: getCurrentMonth(),
    },
  });
  const {params: filterParams} = filterValues;
  const {period} = filterParams;
  const previousMonthDate = getPreviousMonthWithDateParameters(
    period?.from,
    period?.to,
  );
  const {
    user: {employee: employeeId},
  } = useAppStateContext();
  const {colors} = useTheme();
  return (
    <Table
      eventSourceId={'keyperformanceindicators'}
      api={`/kpi/achievement-data`}
      filter={filterValues?.params}
      addOnFilter={{
        owner: employeeId?._id,
      }}
      renderHeader={() => (
        <TableHeader
          title="Key Performance Indicator"
          actions={[
            <PeriodRangeMonthWiseBreakupFilter
              onChangeFilter={onChangeFilter}
              filterValues={filterValues}
              asParam
            />,
            <AddButton
              title="Add"
              view="add-key-perfermance-indicator"
              params={props?.route?.params}
            />,
          ]}
        />
      )}
      // fields={{
      //   kra_id: {name: 1},
      //   name: 1,
      //   description: 1,
      //   api: 1,
      //   entity: {label: 1},
      //   role: 1,
      //   department: {name: 1},
      // }}
      columns={[
        {
          field: 'kra_id.name',
          header: 'KRA',
          responsive: 'sm',
        },
        {
          field: 'kpi_id.name',
          header: 'KPI',
          responsive: 'sm',
        },
        {
          field: 'owner',
          header: 'Owners',
          // responsive: 'sm',
          type: 'userAvatarGroup',
        },
        {
          header: 'Current',
          align: 'right',
          render: CountCellRender,
          count_field: 'current_value',
          width: 150,
          onPress: ({row}) => {
            const route = row?.api?.view;
            navigation.navigate(route, {
              period: {...filterValues?.params?.period},
              forKpi: true,
            });
          },
        },
        {
          header: 'Previous',
          align: 'right',
          render: CountCellRender,
          count_field: 'previous_value',
          width: 150,
          // type: 'text',
          onPress: ({row}) => {
            const route = row?.api?.view;
            navigation.navigate(route, {
              period: {...previousMonthDate},
              forKpi: true,
            });
          },
        },
        {
          field: 'variance',
          header: 'Variance',
          type: 'text',
          width: 150,
          render: ({row}) => {
            let variance =  (row.variance).toString() || "";
            const varArray = variance.split('(')
            variance = varArray[0]
            return (
              <TextRenderer
                style={{
                  color:
                  variance < 0
                      ? colors.ERROR_HIGH
                      : colors.SUCCESS_HIGH,
                }}
                value={
                  row.variance
                }
              />
            )
          }
        },
      ]}
      moreActions={() => [
        // {
        //   title: 'Edit',
        //   onPress: ({row}) => {
        //     navigation.navigate('edit-key-performance-indicator', {row});
        //   },
        // },
        {
          title: 'Delete',
          confirm: {
            title: 'Delete',
            message: 'Are you sure you want to Delete?',
            confirmText: 'Delete',
          },
          onPress: ({row}) => {
            deleteInvoke({
              uri: `/keyperformanceindicators/${row?._id}`,
              props: {},
            });
          },
        },
      ]}
      {...props}
    />
  );
};

export const KeyPerformanceIndicatorAchievementTable = props => {
  const {navigation} = props;

  const {applyFilter, filterValues, onChangeFilter} = useFilter({
    params: {
      period: getCurrentMonth(),
    },
  });
  const {params: filterParams} = filterValues;
  const {period} = filterParams;
  const previousMonthDate = getPreviousMonthWithDateParameters(
    period?.from,
    period?.to,
  );
  const {data, loading} = useFetchData({
    api: '/kpi/achievement-data/recursive',
    filter: filterValues?.params,
    eventSourceId: 'keyperformanceindicators',
  });
  return (
    <Col style={{gap: 8, overflow: 'hidden', flex: 1}}>
      <RecurringTableHOC
        data={data}
        loading={loading}
        params={props}
        filterValues={filterValues}
        previousMonthDate={previousMonthDate}
        onChangeFilter={onChangeFilter}
      />
    </Col>
  );
};

const RecurringTableHOC = ({
  previousMonthDate,
  filterValues,
  onChangeFilter,
  ...props
}) => {
  const {params} = props;
  const {navigation} = params;
  const deleteInvoke = useInvoke({
    method: 'delete',
    eventSourceId: 'keyperformanceindicators',
  });
  const {colors} = useTheme();
  return (
    <RecursiveTable
      {...props}
      renderHeader={() => (
        <TableHeader
          title="Key Performance Indicator"
          actions={[
            <PeriodRangeMonthWiseBreakupFilter
              onChangeFilter={onChangeFilter}
              filterValues={filterValues}
              asParam
            />,
            <AddButton
              title="Add"
              view="add-key-perfermance-indicator"
              params={props?.route?.params}
            />,
          ]}
        />
      )}
      recursiveKey="_children"
      columns={[
        {
          render: RecursiveRender,
          field: 'kra_id.name',
          header: 'KRA',
          responsive: 'sm',
        },
        {
          field: 'kpi_id.name',
          header: 'KPI',
          responsive: 'sm',
        },
        {
          field: 'owner',
          header: 'Owners',
          // responsive: 'sm',
          type: 'userAvatarGroup',
        },
        {
          header: 'Current',
          align: 'right',
          render: CountCellRender,
          count_field: 'current_value',
          width: 150,
          onPress: ({row}) => {
            const route = row?.api?.view;
            navigation.navigate(route, {
              period: {...filterValues?.params?.period},
              forKpi: true,
            });
          },
        },
        {
          header: 'Previous',
          align: 'right',
          render: CountCellRender,
          count_field: 'previous_value',
          width: 150,
          // type: 'text',
          onPress: ({row}) => {
            const route = row?.api?.view;
            navigation.navigate(route, {
              period: {...previousMonthDate},
              forKpi: true,
            });
          },
        },
        {
          field: 'variance',
          header: 'Variance',
          type: 'text',
          width: 150,
          render: ({row}) => {
            let variance =  (row.variance).toString() || "";
            const varArray = variance.split('(')
            variance = varArray[0]
            return (
              <TextRenderer
                style={{
                  color:
                  variance < 0
                      ? colors.ERROR_HIGH
                      : colors.SUCCESS_HIGH,
                }}
                value={
                  row.variance
                }
              />
            )
          }
        },
      ]}
      moreActions={() => [
        // {
        //   title: 'Edit',
        //   onPress: ({row}) => {
        //     navigation.navigate('edit-key-performance-indicator', {row});
        //   },
        // },
        {
          title: 'Delete',
          confirm: {
            title: 'Delete',
            message: 'Are you sure you want to Delete?',
            confirmText: 'Delete',
          },
          onPress: ({row}) => {
            deleteInvoke({
              uri: `/keyperformanceindicators/${row?._id}`,
              props: {},
            });
          },
        },
      ]}
    />
  );
};
